import React from "react"
import {Form, Field, Formik } from "formik";
import ApiService from "../../Services/ApiService.js";
import AlertService from "../../Services/AlertService.js";
import "react-table/react-table.css";
import queryString from "query-string";
import LoadingScreen from "../misc/loading.js";
import CampaignService from "../../Services/CampaignService";

class Overview extends React.Component {

    // default state
    state = {
        data: {
            client_id: "",
            linkedin_campaign_group_id: "",
            campaign_name: "new campaign",
            client_name: "",
            start_date: "",
            end_date: "",
            status: "ACTIVE",
            objective_type: "WEBSITE_VISIT",
            account_status: "ACTIVE",
            run_specific_times: 0,
            run_start_time: '',
            run_end_time: ''
        },
        is_loading: true,
        is_new: true
    };

    componentDidMount() {
        if(this.props.data) {
            if(this.props.data.campaignId) {
                // existing campaign
                const url = "/api/campaigns/fetch?campaign_id=" + this.props.data.campaignId;
                ApiService.get(url)
                    .then(response => {
                        let campaign = response.data.Campaign;
                        if (campaign) {
                            this.setState({
                                ...this.state.data,
                                data: campaign,
                                is_loading: false,
                                is_new: false
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        } else {
            let params = queryString.parse(this.props.location.search);
            this.setState({
                data: { ...this.state.data , client_id: params.client_id},
                is_loading: false,
                is_new: true
            });
        }
    }

    saveChanges = (values) => {
        if(this.state.is_new){
            this.createCampaign(values);
        } else {
            this.updateCampaign(values);
        }
    };

    updateCampaign = (values) => {
       
        //remove the categories field to avoid it getting changed since it cannot be set in the overview page
        values = this.cleanData(values);

        ApiService.post("/api/campaigns/update", values)
            .then(response => {
                if (response.data.Success) {
                    AlertService.success('Campaign saved successfully');
                } else {
                    AlertService.error('Oops! There was an error saving the Campaign');
                }
            })
            .catch(error => {
                AlertService.error('Oops! There was an error saving the Campaign');
            });
    };

    cleanData = (values) => {
        values['campaign_status_id'] = CampaignService.getStatusId(values.status);
        values['campaign_objective_type_id'] = CampaignService.getObjectiveTypeId(values.objective_type);
        values['run_specific_times'] = values['run_specific_times'] ? 1 : 0;

        // remove fields that shouldn't be updated view overview
        delete values['categories'];
        delete values['job_functions'];
        delete values['image_json_a'];
        delete values['image_json_b'];

        return values;
    };
    
    createCampaign = (values) => {
        values['campaign_status_id'] = CampaignService.getStatusId(values.status);
        values['campaign_objective_type_id'] = CampaignService.getObjectiveTypeId(values.objective_type);

        ApiService.post("/api/campaigns/create", values)
            .then(response => {
                this.props.history.push("/campaigns?client_id="+ this.state.data.client_id + "&client_name=" + this.state.data.client_name);
                AlertService.success('Campaign saved successfully');
            })
            .catch(error => {
                AlertService.error('Oops! There was an error saving the Campaign');
            });
    };

    render = () => {
        let form =
            (
                <Formik
                    initialValues={this.state.data}
                    handleChange={this.handleChange}
                    onSubmit={this.saveChanges}
                    render={ ({values, errors, touched, isSubmitting, handleBlur}) => {
                        return (
                            <Form className="form-container">
                                <div className="overview">
                                    <div className="form-col">
                                        <div className="input-group">
                                            <label>
                                                <span>Campaign Group Name</span>
                                                <Field
                                                    className="campaign-name-input"
                                                    type="text"
                                                    name="campaign_name"
                                                    value={values.campaign_name}
                                                />
                                            </label>
                                        </div>
                                        <div className="input-group">
                                            <label>
                                                <span>Start Date</span>
                                                <div>
                                                    <Field
                                                        className="datetime-input"
                                                        type="Date"
                                                        name="start_date"
                                                        value={values.start_date}
                                                    />
                                                </div>
                                            </label>
                                        </div>
                                        <div className="input-group">
                                            <label>
                                                <span>End Date</span>
                                                <div>
                                                    <Field
                                                        className="datetime-input"
                                                        type="Date"
                                                        name="end_date"
                                                        value={values.end_date}
                                                    />
                                                </div>
                                            </label>
                                        </div>

                                        <div className="input-group">
                                            <span className="slider-label"> Run ads between specific times </span>

                                            <label className="switch">
                                                <Field type="checkbox"
                                                       name="run_specific_times"
                                                       checked={values.run_specific_times}
                                                       value={values.run_specific_times.toString()}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>

                                        {values.run_specific_times ? (
                                            <div>
                                                <div className="input-group">
                                                    <Field
                                                        id="runStartTime"
                                                        type="time"
                                                        name="run_start_time"
                                                        value={values.run_start_time}
                                                    />
                                                </div>

                                                <div className="input-group">
                                                    <Field
                                                        id="runEndTime"
                                                        type="time"
                                                        name="run_end_time"
                                                        value={values.run_end_time}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}

                                    </div>
                                    <div className="form-col">
                                        <div className="input-group">
                                            <label>
                                                <span>LinkedIn Campaign Group ID</span>
                                                <Field
                                                    type="text"
                                                    name="linkedin_campaign_group_id"
                                                    value={values.linkedin_campaign_group_id}
                                                />
                                            </label>
                                        </div>
                                        <div className="input-group">
                                            <label>
                                                <span>Objective Type</span>
                                                <Field
                                                    component="select"
                                                    name="objective_type"
                                                    value={values.objective_type}
                                                >
                                                    <option value="BRAND_AWARENESS" className="option">Brand Awareness</option>
                                                    <option value="ENGAGEMENT">Engagement</option>
                                                    <option value="JOB_APPLICANT">Job Applicant</option>
                                                    <option value="LEAD_GENERATION">Lead Generation</option>
                                                    <option value="VIDEO_VIEW">Video View</option>
                                                    <option value="WEBSITE_CONVERSION">Website Conversion</option>
                                                    <option value="WEBSITE_VISIT">Website Visit</option>
                                                </Field>
                                            </label>
                                        </div>
                                        <div className="input-group datetime-input">
                                            <label>
                                                <span>Campaign Status</span>
                                                <Field
                                                    component="select"
                                                    name="status"
                                                    value={values.status}
                                                >
                                                    <option value="ACTIVE" className="option">Active</option>
                                                    <option value="DRAFT">Draft</option>
                                                </Field>
                                            </label>
                                        </div>

                                        <div className="input-group datetime-input">
                                            <label>
                                                <span>Account Status</span>
                                                <Field
                                                    component="select"
                                                    name="account_status"
                                                    value={values.account_status}
                                                >
                                                    <option value="ACTIVE" className="option">Active</option>
                                                    <option value="DRAFT">Draft</option>
                                                    <option value="PAUSED">Paused</option>
                                                </Field>
                                            </label>
                                        </div>
                                    </div>

                                </div>
                                <hr width="1"></hr>
                                <div className="form-submit">
                                    <button>Save</button>
                                    <button type="button" className="outline"
                                            onClick={() => {
                                                this.props.history.push("/campaigns?client_id=" + this.state.data.client_id + "&client_name=" + this.state.data.client_name)
                                            }}>
                                        Cancel
                                    </button>
                                </div>

                            </Form>
                        )
                    }
                    }
                >
                </Formik>
            );

        if(!this.state.is_loading) {
            if (this.props.data) {
                return (
                    <div className="page-main">
                        {form}
                    </div>
                )
            } else {
                return (
                    <div className="page-main">
                        <div className="page-content">
                            {form}
                        </div>
                    </div>
                )
            }
        } else {

            return <LoadingScreen/>;

        }

    }
}



export default Overview